var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTopArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99935 3.33325C10.4596 3.33325 10.8327 3.70635 10.8327 4.16659V15.8333C10.8327 16.2935 10.4596 16.6666 9.99935 16.6666C9.53911 16.6666 9.16602 16.2935 9.16602 15.8333V4.16659C9.16602 3.70635 9.53911 3.33325 9.99935 3.33325Z",
    fill: "#523280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4114 3.57733C9.73683 3.25189 10.2645 3.25189 10.5899 3.57733L16.4232 9.41066C16.7487 9.7361 16.7487 10.2637 16.4232 10.5892C16.0978 10.9146 15.5702 10.9146 15.2447 10.5892L10.0007 5.3451L4.75657 10.5892C4.43114 10.9146 3.9035 10.9146 3.57806 10.5892C3.25263 10.2637 3.25263 9.7361 3.57806 9.41066L9.4114 3.57733Z",
    fill: "#523280"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTopArrow);
export default __webpack_public_path__ + "static/media/icon-top-arrow.a8c096f82e28f51102d0f1d56996257a.svg";
export { ForwardRef as ReactComponent };